export default "__VITE_ASSET__DE9S143F__"